import { render, staticRenderFns } from "./PostProduction.vue?vue&type=template&id=e43a8556&scoped=true&"
import script from "./PostProduction.vue?vue&type=script&lang=js&"
export * from "./PostProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43a8556",
  null
  
)

export default component.exports